export const isAdmin = (user) => (
  user.role === "admin" || user.role === "super admin"
)



// WEBPACK FOOTER //
// ./src/utils/auth.js